import { useLazyQuery } from "@apollo/client/react";
import { Button } from '@mui/material';
import React, { useMemo, useState, useEffect } from 'react';
import { BuscarClientes } from './BuscarClientes';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import GrillaVacia from '../../../../assets/images/grillavacia-plancuidado.svg';
import Chip from '@mui/material/Chip';
import toast, { Toaster } from 'react-hot-toast';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { GET_DELEGACIONES } from '../../../../data/graphQL/queries/Planes/getDelegaciones';
import { adaptDelegacionArray } from '../../../../adapters/delegacionAdapter';
import { CustomButton } from '../../../../components/customButton/CustomButton';

export const StepClientes = ({ stepsData, setStepsData }) => {

  const initialColumns = [
    {
      field: 'codigoSapCliente',
      headerName: 'Cod cliente'
    },
    {
      field: 'nombre',
      headerName: 'Cliente'
    },
    {
      field: 'codigoEspCliente',
      headerName: 'Cod. Financiador'
    },
    {
      field: 'requiereFacturacion',
      headerName: 'Factura',
      type: 'boolean'
    },
    {
      headerName: 'Atributos',
      field: 'atributos',
      flex: 0.4,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const propsAModificar = Object.entries(row)?.map(([key, _]) => key).filter((nombre) => nombre.includes('atributo'));
        const renderChips = Object.entries(row)?.
          filter(([key, _]) => propsAModificar.includes(key))?.
          map(([_, value], index) => {
            if (value !== '') {
              return (
                <Chip key={value + index} label={value} />);

            }
          });
        return renderChips;
      }
    },
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div
                  onClick={() => handleEditRowClick(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
                <div
                  onClick={() => handleDeleteRowClick(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <DeleteOutlineIcon className='edit-icon' />
                  <span className='toggle-action'>Eliminar</span>
                </div>
              </div>
            </PopoverModal>
          </>);

      }
    }];

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editRow, setEditRow] = useState({});
  const [allDelegaciones, setAllDelegaciones] = useState();

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!delegacionesData) return;
    const selectedDelegaciones = adaptDelegacionArray(delegacionesData)
      ?.filter(d =>
        stepsData?.delegaciones
          ?.map(sd => sd.idDelegacion)
          ?.includes(d.id)
      );
    setAllDelegaciones(selectedDelegaciones);
  }, [delegacionesData])

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({
        variables: {
          where: {
            or: [
              { descripcion: { ncontains: 'CASA CENTRAL' } }
            ]
          },
          order: [{ descripcion: 'ASC' }]
        }
      });
    }
  }, [])

  const handleEditRowClick = (editCliente) => {
    setEditRow(editCliente);
    setModalIsOpen(true);
  };

  const handleDeleteRowClick = (row) => {
    setStepsData((previousData) => ({
      ...previousData,
      clientes: [...previousData.clientes.filter((c) => c.codigoSapCliente !== row.codigoSapCliente)]
    }));
  };

  const handleRowClick = (newCliente) => {
    if (isValid(newCliente)) {
      setStepsData((previousData) => ({ ...previousData, clientes: [...(previousData.clientes || []), newCliente] }));
      setModalIsOpen(false);
      setEditRow({});
    }
  };

  const isValid = (newCliente) => {
    if (newCliente.codigoSapCliente.length <= 0) {
      toast.error('Debe ingresar el Cliente');
      return false;
    }
    if (newCliente.codigoEspCliente.length <= 0) {
      toast.error('Debe ingresar el Código de financiador');
      return false;
    }
    if (newCliente.nombre.length <= 0) {
      toast.error('Debe ingresar el nombre');
      return false;
    }
    return true;
  };

  const handleEditSaveRowClick = (editCliente, clientId) => {
    let cliente = {
      codigoSapCliente: editCliente.codigoSapCliente,
      nombre: editCliente.nombre,
      requiereFacturacion: editCliente.requiereFacturacion,
      codigoEspCliente: editCliente.codigoEspCliente,
      atributo1: editCliente.atributo1,
      atributo2: editCliente.atributo2,
      atributo3: editCliente.atributo3,
      atributo4: editCliente.atributo4,
      atributo5: editCliente.atributo5
    };

    if (editCliente.idPlanCuidadoAtributo) cliente.idPlanCuidadoAtributo = editCliente.idPlanCuidadoAtributo;
    if (editCliente.idPlanCuidado) cliente.idPlanCuidado = editCliente.idPlanCuidado;

    setStepsData((previousData) => ({
      ...previousData,
      clientes: [...(previousData?.clientes || []).filter((c) => c.codigoSapCliente !== clientId), cliente]
    }));

    setEditRow({});
    setModalIsOpen(false);
  };

  const handleClickAgregarCliente = () => {
    setEditRow({});
    setModalIsOpen(true);
  };
  return (
    <>
      <div>
        {stepsData?.clientes?.length == 0 &&
          <div className='clientes-gilla-vacia'>
            <div className='svg-clientes-grilla-vacia'>
              <img src={GrillaVacia} width="100%"></img>
            </div>
            <label>No se ha creado ningun cliente.</label>
            <CustomButton
              onClick={() => setModalIsOpen(true)}
              size='small'>

              Crear
            </CustomButton>
          </div>
        }
        {stepsData?.clientes?.length > 0 &&
          <>
            <div className='button-agregar-cliente'>
              <CustomButton
                onClick={handleClickAgregarCliente}
                size='small'>

                Agregar cliente
              </CustomButton>
            </div>
            <div className='clientes-grilla'>
              <DataGridGenerico
                hideFooterPagination={true}
                toolbar={false}
                columns={columns}
                rows={stepsData?.clientes} />

            </div>
          </>
        }
        <BuscarClientes
          open={modalIsOpen}
          onRowClick={handleRowClick}
          onEditRowClick={handleEditSaveRowClick}
          onClose={() => setModalIsOpen(false)}
          rowData={editRow}
          delegacionesData={allDelegaciones} />

      </div>

    </>);

};